import { registerPlugin } from "@capacitor/core";
const NavigationBarInfo = registerPlugin("NavigationBarInfo", {
    web: () => import("./web").then((m) => new m.NavigationBarInfoWeb()),
});
export * from "./definitions";
export { NavigationBarInfo };
//# sourceMappingURL=index.js.map